import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
interface Establecimiento{
  value: number;
  name: string;
}
@Component({
  selector: 'app-agregar-alarmas',
  templateUrl: './agregar-alarmas.component.html',
  styleUrls: ['./agregar-alarmas.component.css']
})
export class AgregarAlarmasComponent {

  waitAfterSave: boolean = false;
  alarmasCreadas: boolean = false;
  errorFinal: boolean = false;
  errorMessage : string ="";

  //ESTABLECIMIENTOS
  selectedEstablecimiento: number [] = [];
  establecimientosCopia: Establecimiento[] = [];
  selectAllEstablecimientos: boolean = false;
  ningunEstablecimientoSeleccionado: boolean = false;

  //CONFIGURACIÓN DE ALARMAS
  configuracionAlarmas: FormGroup = new FormGroup({
    nivelCerveza: new FormControl('', [
      Validators.min(0),
      Validators.max(100),
      (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
          return null;
        }
        //Tenemos que substituir la coma por el punto para que realice bien la comprobación
        const sanitizedValue = value.replace(',', '.');
        if (!/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/.test(sanitizedValue)) {
          return { pattern: true };
        }
        const numericValue = parseFloat(sanitizedValue);
        if (isNaN(numericValue)) {
          return { pattern: true };
        }
    
        if (numericValue < 0) {
          return { min: true };
        }
        if (numericValue > 100) {
          return { max: true };
        }
        return null;
      },
    ]),
    temperaturaTanqueMin: new FormControl('', [Validators.pattern(/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/)]),
    temperaturaTanqueMax: new FormControl('', [Validators.pattern(/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/)]),
    presionMax: new FormControl('', [Validators.pattern(/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/)]),
    presionMin: new FormControl('', [Validators.pattern(/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/)]),
  });
  errorCamposIncorrectos: boolean = false;

  //SUBSCRIPCIONES
  private clientsSubscription: Subscription | undefined;
  private añadirAlarmasMasivasSubscription: Subscription | undefined;

  constructor(private deviceService: DeviceService, private error429: Error429Service){}

  ngOnInit(): void {
    this.clientsSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          this.establecimientosCopia.push({
            value: resp[i].id,
            name: resp[i].est_name
          });
        }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{}
    })
  }

  ngOnDestroy(): void {
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
    if (this.añadirAlarmasMasivasSubscription) {
      this.añadirAlarmasMasivasSubscription.unsubscribe();
    } 
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  selectAllEstablecimientosChanged() {
    if (this.selectAllEstablecimientos) {
      this.selectedEstablecimiento = this.establecimientosCopia.map(establecimiento => establecimiento.value);
    } else {
      this.selectedEstablecimiento = [];
    }
  }

  get nivelCervezaInput() { 
    return this.configuracionAlarmas.get('nivelCerveza'); 
  }
  get temperaturaTanqueMinInput() { 
    return this.configuracionAlarmas.get('temperaturaTanqueMin'); 
  }
  get temperaturaTanqueMaxInput() { 
    return this.configuracionAlarmas.get('temperaturaTanqueMax'); 
  }
  get presionMinInput() { 
    return this.configuracionAlarmas.get('presionMin'); 
  }
  get presionMaxInput() { 
    return this.configuracionAlarmas.get('presionMax'); 
  }

  guardarDispositivo() {
    this.errorCamposIncorrectos = false;
    this.ningunEstablecimientoSeleccionado = false;
    //Comprobar si hay campos introducidos incorrectamente
    if(this.configuracionAlarmas.get('nivelCerveza')?.hasError('pattern') || this.configuracionAlarmas.get('nivelCerveza')?.hasError('min')
    || this.configuracionAlarmas.get('nivelCerveza')?.hasError('max') || this.configuracionAlarmas.get('temperaturaTanqueMin')?.hasError('pattern')
    || this.configuracionAlarmas.get('temperaturaTanqueMax')?.hasError('pattern') || this.configuracionAlarmas.get('presionMax')?.hasError('pattern')
    || this.configuracionAlarmas.get('presionMin')?.hasError('pattern')){
      this.errorCamposIncorrectos = true;
    }

    if(this.selectedEstablecimiento.length == 0){
      this.ningunEstablecimientoSeleccionado = true;
    }

    if(!this.errorCamposIncorrectos && !this.ningunEstablecimientoSeleccionado){

      const alarmas = {
        beerLevelMin: this.nivelCervezaInput?.value && typeof this.nivelCervezaInput.value === 'string'
          ? parseFloat(this.nivelCervezaInput.value.replace(',', '.'))
          : parseFloat(this.nivelCervezaInput?.value),
        beerTemperatureMin: this.temperaturaTanqueMinInput?.value && typeof this.temperaturaTanqueMinInput.value === 'string'
          ? parseFloat(this.temperaturaTanqueMinInput.value.replace(',', '.'))
          : parseFloat(this.temperaturaTanqueMinInput?.value),
        beerTemperatureMax: this.temperaturaTanqueMaxInput?.value && typeof this.temperaturaTanqueMaxInput.value === 'string'
          ? parseFloat(this.temperaturaTanqueMaxInput.value.replace(',', '.'))
          : parseFloat(this.temperaturaTanqueMaxInput?.value),
        beerPressureMin: this.presionMinInput?.value && typeof this.presionMinInput.value === 'string'
          ? parseFloat(this.presionMinInput.value.replace(',', '.'))
          : parseFloat(this.presionMinInput?.value),
        beerPressureMax: this.presionMaxInput?.value && typeof this.presionMaxInput.value === 'string'
          ? parseFloat(this.presionMaxInput.value.replace(',', '.'))
          : parseFloat(this.presionMaxInput?.value),
      };
      console.log(alarmas);
      const jsonAlarms = JSON.stringify(alarmas);
      const jsonEstablishmentsIds = JSON.stringify(this.selectedEstablecimiento);

      console.log(jsonAlarms);
      console.log(jsonEstablishmentsIds);
      const alarmasData = new FormData();
      alarmasData.append('_method', "PATCH");
      alarmasData.append('establishments', jsonEstablishmentsIds);
      alarmasData.append('alarm_ranges', jsonAlarms);

      this.añadirAlarmasMasivasSubscription = this.deviceService.alarmasMasivas(alarmasData).subscribe({
        next: resp =>{
        },error: err =>{
          this.errorMessage = err.error.message;
          if(this.errorMessage == undefined){
            this.errorMessage = err.error.error;
          }
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.errorFinal = true;
            setTimeout(() => {
              this.errorFinal = false;
              this.waitAfterSave = false;
            },3500)
          }
        },complete: () =>{
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.alarmasCreadas = true;
            setTimeout(() => {
              this.selectedEstablecimiento = [];
              this.configuracionAlarmas.setValue({
                nivelCerveza: '',
                temperaturaTanqueMin: '',
                temperaturaTanqueMax: '',
                presionMax: '',
                presionMin: ''
              });
              this.waitAfterSave = false;
              this.alarmasCreadas = false;
            }, 3500);
          }
        }
      });
    }

    console.log('Establecimientos seleccionados: ',this.selectedEstablecimiento);
    console.log('Nivel mínimo de cerveza(%): ',this.nivelCervezaInput?.value);
    console.log('Temperatura mínima tanque: ',this.temperaturaTanqueMinInput?.value);
    console.log('Temperatura máxima tanque: ',this.temperaturaTanqueMaxInput?.value);
    console.log('Presion minima: ',this.presionMinInput?.value);
    console.log('Presion máxima: ',this.presionMaxInput?.value);

    console.log("--------------------------------");
  }
}
